export const aciPoolBar = {
    iconName: 'pool-bar',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 25' },
        path: [
            {
                attr: {
                    d: 'M9.017 16.862h4.32M11.178 16.142v-3.6M4 3.001h1.83a1.08 1.08 0 01.967.597l1.322 2.644',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M16.733 6.242a.542.542 0 01.537.593 5.941 5.941 0 01-11.822 0 .542.542 0 01.538-.594h10.747zM14.654 6.246a2.701 2.701 0 112.248 2.127M18.35 20.164c-1.458.276-2.363-1.049-2.363-1.049a2.477 2.477 0 01-.903.786c-.368.19-.781.295-1.204.304-.4-.007-.79-.112-1.129-.304a2.115 2.115 0 01-.8-.786 3.024 3.024 0 01-1.013.774c-.395.188-.83.296-1.275.316a2.881 2.881 0 01-1.195-.316 2.6 2.6 0 01-.91-.774s-1.168 1.35-2.595 1.07M18.35 22.613c-1.458.277-2.363-1.049-2.363-1.049a2.477 2.477 0 01-.903.786c-.368.19-.781.295-1.204.304-.4-.007-.79-.112-1.129-.304a2.115 2.115 0 01-.8-.786 3.024 3.024 0 01-1.013.774c-.395.188-.83.296-1.275.316a2.881 2.881 0 01-1.195-.316 2.6 2.6 0 01-.91-.774s-1.168 1.35-2.595 1.07',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
